import type { ThemeUICSSObject } from 'theme-ui';

export const sunriseGradientBorder: ThemeUICSSObject = {
	borderStyle: 'none',
	position: 'relative',
	// eslint-disable-next-line @typescript-eslint/naming-convention
	'&::before': {
		content: '""',
		position: 'absolute',
		inset: 0,
		borderRadius: 'inherit',
		padding: '2px', // border width
		background: 'linear-gradient(0deg,#FE9311,#FFDB00)', // orange.500 to yellow.400
		mask: 'linear-gradient(#000 0 0) content-box exclude, linear-gradient(#000 0 0)',
		maskComposite: 'exclude',
	},
};
